module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "title": 'Backhaul ' + (this.sharerId ? 'Customers' : 'Providers'),
      "icon": "fa fa-wifi",
      "table-ref": "backhaultable",
      "url": '/backhaul' + (this.provider ? '' : '/subscribers') +
        (this.siteId ? '/site/' + Number(this.siteId) : '') + (this.sharerId ? '/org/' + Number(this.sharerId) : ''),
      "fields": _vm.backhaulFields,
      "add-action": !_vm.isTowerCo() || _vm.noAdd ? null : _vm.showProviderSelect ? _vm.selectProvider : _vm.addBackhaul,
      "add-props": !_vm.isTowerCo() || _vm.noAdd ? null : _vm.addProps,
      "hide-org-badge": this.siteId ? true : false,
      "sort-field": "backhaulType",
      "search-placeholder": "Providers, Site Names...",
      "detail-component": (!_vm.isTowerCo()) ? null : (_vm.provider ?
        'backhaul-provider-row' :
        'backhaul-customer-row')
    },
    scopedSlots: _vm._u([{
      key: "subscribers",
      fn: function(props) {
        return [_c('span', {}, [_vm._v(_vm._s(_vm.formatUsers(props)))])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1783370"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backhaul/BackhaulTable.vue
// module id = 1693
// module chunks = 0